export const DD_CI_IDENTIFYING_STRING = 'DdCiLogGroupSubscription'
export const DD_TRACE_ENABLED = 'DD_TRACE_ENABLED'
export const TAG_VERSION_NAME = 'dd_sls_ci'
